// Module
var code = "<h2 id=\"account-access\">Account Access</h2> <p>Make payments, check balances, and manage your account online&mdash;quickly, easily, and securely.</p> ";
// Exports
export default code;